import { gql } from '__generated__';

export default gql(`
  mutation EditTeam($input: EditTeamInput!) {
    editTeam(input: $input) {
      ...TeamFields
    }
  }
`);
